import React, {FC, memo, useCallback, useEffect, useState} from "react";
import {ModalProps} from "react-bootstrap/Modal";
import {useDispatch, useSelector} from "react-redux";
import {AppDispatch, IRootState} from "../../../store/configureStore";
import {actions as websocket, IReceiverControl} from "../../../store/sliceWebsocket";
import {NetUsbArticle, NetUsbContainer, NetUsbControlButton, NetUsbHeader, NetUsbSection} from "./NetUsbControlStyle";
import {Button, FormControl} from "react-bootstrap";
import {ArrowLeft, ArrowReturnLeft, ArrowRight, Play} from "react-bootstrap-icons";
import {isDigit, replaceUnderline} from "../../../utils/Util";


interface NetUsbControlProps {
    input: string,
    iReceiverControl: IReceiverControl
}

const NetUsbControl: FC<ModalProps & NetUsbControlProps> = ({input, iReceiverControl}) => {

    const dispatch = useDispatch<AppDispatch>();
    const [valueIndex, setValueIndex] = useState<number>(0)

    // const iReceiverControl: IReceiverControl =
    //     useSelector((state: IRootState) => input == 'usb' ? state.websocket.receiverUsbControl : state.websocket.receiverUsbControl)


    useEffect(() => {
        setValueIndex(iReceiverControl.index)
    }, [iReceiverControl.index])


    const onAction = useCallback((index: number, type: string) => {
        dispatch(websocket.send({
            body: JSON.stringify({index: index + valueIndex, type: type, input: input}),
            topic: `${input == 'usb' ? "/app/receiver.usb.settings" : "/app/receiver.netRadio.settings"}`
        }))
    }, [valueIndex, input])

    const onInput = useCallback((event: React.ChangeEvent<HTMLInputElement>) => {
        if (isDigit(event.target.value)) {
            setValueIndex(Number(event.target.value))
        }
    }, [])


    const onMove = useCallback((mode: string) => {
        if (mode === 'up' && iReceiverControl.max_line - valueIndex > 8) {
            dispatch(websocket.send({
                body: JSON.stringify({index: `${valueIndex + 8}`, input: input}),
                topic: `${input == 'usb' ? "/app/receiver.usb.info" : "/app/receiver.netRadio.info"}`
            }))
        }
        if (mode === 'down' && valueIndex >= 8) {
            dispatch(websocket.send({
                body: JSON.stringify({index: `${valueIndex - 8}`, input: input}),
                topic: `${input == 'usb' ? "/app/receiver.usb.info" : "/app/receiver.netRadio.info"}`
            }))
        }
        if (mode === 'down' && valueIndex < 8) {
            dispatch(websocket.send({
                body: JSON.stringify({index: `0`, input: input}),
                topic: `${input == 'usb' ? "/app/receiver.usb.info" : "/app/receiver.netRadio.info"}`
            }))
        }
    }, [valueIndex, iReceiverControl.max_line, input])

    const onKeyDown = useCallback((e: React.KeyboardEvent<HTMLInputElement>) => {
        if (e.key === 'Enter') {
            dispatch(websocket.send({
                body: JSON.stringify({index: valueIndex, input: input}),
                topic: `${input == 'usb' ? "/app/receiver.usb.info" : "/app/receiver.netRadio.info"}`
            }))
        }
    }, [valueIndex, input])

    const onUpdate = useCallback(() => {
        dispatch(websocket.send({
            body: JSON.stringify({index: 0, input: input}),
            topic: `${input == 'usb' ? "/app/receiver.usb.info" : "/app/receiver.netRadio.info"}`
        }))
    },[input])

    if (iReceiverControl?.index == null) {
        return <>
            <Button variant="outline-success" onClick={onUpdate}>Обновить</Button>
        </>
    }

    return (
        <NetUsbSection>
            {/*<Button variant="outline-success" onClick={onUpdate}>Обновить</Button>*/}
            <NetUsbHeader>Папка: {iReceiverControl.menu_name}
            </NetUsbHeader>
            <NetUsbContainer>
                {iReceiverControl?.list_info.map((info, number) => {
                    return (
                        <NetUsbArticle>
                            <div onClick={event => onAction(number, "select")}>
                                {replaceUnderline(info.text)}
                            </div>
                            {info.attribute && info.attribute !== 2 && info.attribute !== 10 && info.attribute !== 125829122 &&
                                <Play onClick={event => onAction(number, "play")} size={30}/>}
                        </NetUsbArticle>
                    )
                })}
            </NetUsbContainer>
            <NetUsbControlButton>
                <Button variant="outline-success" disabled={iReceiverControl.menu_layer === 0}
                        onClick={() => onAction(0, "return")}><ArrowReturnLeft size={20}/></Button>
                <Button variant="outline-success" disabled={valueIndex === 0} onClick={() => onMove('down')}><ArrowLeft
                    size={20}/></Button>
                <FormControl style={{width: "70px"}} type={"text"} value={valueIndex} onChange={onInput}
                             onKeyDown={onKeyDown}/>
                <NetUsbHeader>из {iReceiverControl.max_line}</NetUsbHeader>
                <Button variant="outline-success" disabled={(iReceiverControl.max_line - valueIndex) < 8}
                        onClick={() => onMove('up')}><ArrowRight size={20}/></Button>
            </NetUsbControlButton>
        </NetUsbSection>
    )

}
export default memo(NetUsbControl)
